// extracted by mini-css-extract-plugin
export default {"root":"SearchField_root__7nN2v","is-open":"SearchField_is-open__MXk3P","open-button":"SearchField_open-button__eOubr","search-icon":"SearchField_search-icon__pVprH"};